// extracted by mini-css-extract-plugin
module.exports = {"box":"ReviewBox_box__2GsAc","icon":"ReviewBox_icon__1_tzo","item":"ReviewBox_item__1ixvZ"};